import { render, staticRenderFns } from "./speedSetting.vue?vue&type=template&id=74965ba0&scoped=true&"
import script from "./speedSetting.vue?vue&type=script&lang=js&"
export * from "./speedSetting.vue?vue&type=script&lang=js&"
import style0 from "./speedSetting.vue?vue&type=style&index=0&id=74965ba0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74965ba0",
  null
  
)

export default component.exports